/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Field_AttemptsInputs */

const en_cna_field_attempts = /** @type {(inputs: Cna_Field_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of contact attempts`)
};

const ja_cna_field_attempts = /** @type {(inputs: Cna_Field_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連絡試行回数`)
};

const fr_cna_field_attempts = /** @type {(inputs: Cna_Field_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de tentatives de contact`)
};

const de_cna_field_attempts = /** @type {(inputs: Cna_Field_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Kontaktversuche`)
};

/**
* | output |
* | --- |
* | "Number of contact attempts" |
*
* @param {Cna_Field_AttemptsInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_field_attempts = /** @type {((inputs?: Cna_Field_AttemptsInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Field_AttemptsInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_field_attempts(inputs)
	if (locale === "ja") return ja_cna_field_attempts(inputs)
	if (locale === "fr") return fr_cna_field_attempts(inputs)
	return de_cna_field_attempts(inputs)
});